var map = {
	"./en.ts": [
		9824
	],
	"./es.ts": [
		2307,
		307
	],
	"./index.ts": [
		8087
	],
	"./patientReferralForm/en.ts": [
		6763
	],
	"./patientReferralForm/es.ts": [
		9739,
		120
	],
	"./patientReferralForm/zh-CHS.ts": [
		9635,
		635
	],
	"./patientReferralForm/zh-TW.ts": [
		2754,
		754
	],
	"./zh-CHS.ts": [
		3007,
		388
	],
	"./zh-TW.ts": [
		5787,
		787
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 109;
module.exports = webpackAsyncContext;